import { Injectable } from '@angular/core';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { take } from 'rxjs/operators';

import { AlertService } from '@nano/common/alert';
import { ModalClasses, ModalSize, ModalVerticalDivider } from '@nano/common/modal';
import { popSentryFeatureTagOverride, pushSentryFeatureTagOverride } from '../../core/integration/sentry/sentry-feature-tag';
import { Payment } from '../payment';
import { PaymentComponent } from '../payment.component';
import { PaymentService } from '../payment.service';

export const PAYMENT_MODAL_CLASS = 'app-payment-modal';

@Injectable({ providedIn: 'root' })
export class PaymentModalService {
  private modal: NzModalRef;
  private readonly EXTENDED_MODAL_CLASS = `${PAYMENT_MODAL_CLASS}
  ${ModalClasses.modalSize(ModalSize.LG)}
  ${ModalClasses.modalVerticallyDivided}
  ${ModalClasses.modalVerticallyDividedIn(ModalVerticalDivider.half)}`;

  constructor(
    private alertService: AlertService,
    private modalService: NzModalService,
    private paymentService: PaymentService
  ) {}

  openModal(payment?: Payment): void {
    this.alertService.cleanUp();
    pushSentryFeatureTagOverride('payments');

    if (payment?.beneficiaryAccountNumber === null || payment?.editStandingOrderId !== null) {
      this.paymentService.cleanUpPaymentSummary();
    }

    if (payment?.hasAdditionalInfo) {
      payment.hasAdditionalInfo = !(
        payment.hasPayerAddressInfo &&
        !payment.hasPaymentIdentificationInfo &&
        !payment.hasInitialPayerIdentificationInfo &&
        !payment.hasInitialPayerIdentificationAddressInfo &&
        !payment.hasInitialPayerInfo &&
        !payment.hasPayerIdentificationInfo &&
        !payment.hasReceiverInfo &&
        !payment.hasUltimateReceiverInfo
      );
    }

    const className = payment?.hasAdditionalInfo ? this.EXTENDED_MODAL_CLASS : `${PAYMENT_MODAL_CLASS}`;

    this.modal = this.modalService.create({
      nzContent: PaymentComponent,
      nzData: { payment },
      nzFooter: null,
      nzClosable: false,
      nzMaskClosable: false,
      nzClassName: className
    });

    this.modal.afterClose.pipe(take(1)).subscribe(() => {
      popSentryFeatureTagOverride('payments');
    });
  }

  updateModalClassToExtended(): void {
    setTimeout(() => {
      this.modal?.updateConfig({
        nzClassName: this.EXTENDED_MODAL_CLASS
      });
    }, 0);
  }

  closeModal(): void {
    this.modal?.close();
  }
}
